module.exports = __webpack_public_path__ + "img/ico-12.0eea1513.svg";